import { RegionState } from 'Application/models';
import { getRegions } from 'Application/service/RegionService';
import { create } from 'zustand';

export const useRegionStore = create<RegionState>((set, _get) => ({
    isLoading: false,
    isError: false,
    error: null,
    regions: null,

    getRegions: async () => {
        set({ isLoading: true });

        try {
            const response = await getRegions();
            set({
                isError: false,
                error: null,
                regions: response
            });
        } catch (error) {
            set({ error: 'Failed to get exchangeRate', isError: true });
            throw error;
        } finally {
            set({ isLoading: false });
        }
    }
}));
